import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;

// All member-app requests use cookies for auth
export const memberApi = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Auto-refresh access token on 401 (single retry)
let isRefreshing = false;
memberApi.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url.includes("/api/auth/")) {
      if (isRefreshing) return Promise.reject(error);
      original._retry = true;
      isRefreshing = true;
      try {
        await memberApi.post("/api/auth/refresh");
        isRefreshing = false;
        return memberApi(original);
      } catch (e) {
        isRefreshing = false;
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

// Safely format a FastAPI error detail for display
export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
